import {
  HasuraDataTableColumnDef,
  DataTableEx,
  DataTableExProps,
  DataTableExRef,
  FormInput,
} from '@kirz/mui-admin';
import React, {
  forwardRef,
  Ref,
  useImperativeHandle,
  useMemo,
  useRef,
} from 'react';

export const ClientsTable = forwardRef(
  (
    props: Partial<DataTableExProps> & {
      id: string;
      filterColumns?: (
        columns: HasuraDataTableColumnDef[],
      ) => HasuraDataTableColumnDef[];
    },
    ref: Ref<DataTableExRef>,
  ) => {
    const { filterColumns, ...rest } = props;
    const tableRef = useRef<DataTableExRef>(null);

    useImperativeHandle(ref, () => tableRef.current!, []);

    const columns = useMemo<HasuraDataTableColumnDef[]>(
      () =>
        (filterColumns || ((x: HasuraDataTableColumnDef[]) => x))([
          {
            field: 'id',
            headerName: 'ID',
            width: 120,
          },
          {
            field: 'tokens',
            headerName: 'Токены',
            width: 150,
            type: 'number',
          },
          {
            field: 'hasPremium',
            headerName: 'Премиум',
            width: 150,
            type: 'boolean',
          },
          {
            field: 'createdAt',
            headerName: 'Дата создания',
            type: 'date',
            flex: 1,
          },
        ]),
      [filterColumns],
    );

    return (
      <DataTableEx
        {...rest}
        ref={tableRef}
        source="client"
        columns={columns}
        persistStateMode="query"
        sortBy={rest.sortBy ?? { field: 'createdAt', sort: 'desc' }}
        // editable={false}
        deletable={false}
        disableRemovedFilter
      >
        <FormInput name="tokens" label="Токены" type="number" required />
      </DataTableEx>
    );
  },
);
